/** Pre-login marketing site — main nitromule.com only (not portals). */

import { NM_WORDMARK_DARK_URL, NM_WORDMARK_LIGHT_URL } from '@shared/brandingAssets.js';

export { isMarketingDocumentPath, MARKETING_DOCUMENT_SEGMENTS } from '@shared/marketingDocumentRoute.js';

/** Wordmark logo — marketing header (pre-login). */
export const MARKETING_LOGO_URL = NM_WORDMARK_LIGHT_URL;
export const MARKETING_LOGO_DARK_URL = NM_WORDMARK_DARK_URL;

/** Rocket mule mascot — hero accents on marketing pages. */
export { MARKETING_MASCOT_URL } from '@shared/marketingAssets.js';

export const MARKETING_TAB_IDS = [
  "marketing-portals",
  "marketing-shipping",
  "marketing-solutions",
  "marketing-integrations",
  "marketing-pricing",
];

export const MARKETING_NAV_TABS = [
  { key: "marketing-portals", label: "Portals" },
  { key: "marketing-shipping", label: "Shipping" },
  { key: "marketing-solutions", label: "Solutions" },
  { key: "marketing-integrations", label: "Integrations" },
  { key: "marketing-pricing", label: "Pricing" },
];

export const MARKETING_TAB_PATHS = {
  home: "/",
  "marketing-portals": "/portals",
  "marketing-shipping": "/shipping",
  "marketing-solutions": "/solutions",
  "marketing-integrations": "/integrations",
  "marketing-pricing": "/pricing",
};

/** Paths where the header overlays the hero band until scroll. */
export const MARKETING_HERO_HEADER_PATHS = new Set(
  Object.values(MARKETING_TAB_PATHS).map(path => path.replace(/\/$/, "") || "/")
);

/** Keep in sync with MarketingHeader scroll threshold. */
export const MARKETING_HEADER_SCROLL_THRESHOLD = 12;

const MARKETING_TAB_TO_PAGE_THEME = {
  home: "home",
  "marketing-portals": "portals",
  "marketing-shipping": "shipping",
  "marketing-solutions": "solutions",
  "marketing-integrations": "integrations",
  "marketing-pricing": "pricing",
};

export function getMarketingHeroHeaderTheme(pathname) {
  const norm = String(pathname || "").split("?")[0].replace(/\/$/, "") || "/";
  if (!MARKETING_HERO_HEADER_PATHS.has(norm)) return null;
  const tab = MARKETING_PATH_TO_TAB[norm];
  return MARKETING_TAB_TO_PAGE_THEME[tab] ?? null;
}

export function isMarketingHeroHeaderPath(pathname) {
  return getMarketingHeroHeaderTheme(pathname) != null;
}

/** Dark hero bands use white nav + inverted logo in the overlay header. */
export function isMarketingHeroHeaderDarkTheme(theme) {
  return theme === "home" || theme === "portals" || theme === "shipping" || theme === "pricing" || theme === "integrations";
}

/** Light hero top (white) — keep default dark logo and nav over the hero band. */
export function isMarketingHeroHeaderLightTheme(theme) {
  return theme === "solutions";
}

export const MARKETING_PATH_TO_TAB = Object.fromEntries(
  Object.entries(MARKETING_TAB_PATHS).map(([tab, path]) => [path.replace(/\/$/, "") || "/", tab])
);

export function isMarketingTab(tab) {
  return tab === "home" || MARKETING_TAB_IDS.includes(tab);
}

export function isMainSiteMarketingExperience({ isPortalMode, isUserLoggedIn, activeTab }) {
  if (isPortalMode || isUserLoggedIn) return false;
  return isMarketingTab(activeTab);
}

export function marketingTabFromPath(pathname) {
  const norm = String(pathname || "").split("?")[0].replace(/\/$/, "") || "/";
  return MARKETING_PATH_TO_TAB[norm] || null;
}

export function getMarketingPathForTab(tab) {
  return MARKETING_TAB_PATHS[tab] ?? null;
}
